import {
  LineGallery,
  LineLink,
  LineLocation,
  LineSearchNormal,
  LineTag,
  LineText,
  LineVideoPlay,
} from '@viewup/ui';
import type { PostCampaignCardStatus } from '../../model/types/postCampaignStatus.types';
import type { ProgressIconProps } from '../ProgressIcon';

export const progressStyle: Record<
  PostCampaignCardStatus,
  Record<
    'apply' | 'edit' | 'submit',
    {
      color?: ProgressIconProps['color'];
      status: ProgressIconProps['status'];
    }
  >
> = {
  // 신청전
  BEFORE_APPLICATION: {
    apply: { color: 'info', status: 'notStarted' },
    edit: { status: 'disable' },
    submit: { status: 'disable' },
  },
  // 미제출
  DEDUCT: {
    apply: { color: 'info', status: 'done' },
    edit: { color: 'info', status: 'done' },
    submit: { color: 'danger', status: 'final' },
  },
  // 작성중
  DRAFT: {
    apply: { color: 'info', status: 'done' },
    edit: { color: 'info', status: 'inProgress' },
    submit: { status: 'disable' },
  },
  // 제출 1시간 전
  NEAR_DUE: {
    apply: { color: 'info', status: 'done' },
    edit: { color: 'info', status: 'done' },
    submit: { color: 'danger', status: 'inProgress' },
  },
  // 제출
  SUBMITTED: {
    apply: { color: 'info', status: 'done' },
    edit: { color: 'info', status: 'done' },
    submit: { color: 'info', status: 'final' },
  },
};

const optionIconMap = {
  hashTag: LineTag,
  keyword: LineSearchNormal,
  link: LineLink,
  picture: LineGallery,
  place: LineLocation,
  text: LineText,
  video: LineVideoPlay,
};

export const getOptionIcon = (option: string) => {
  return optionIconMap[option as keyof typeof optionIconMap];
};
